import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'sticky bottom-0 left-0 z-60 flex w-full flex-col bg-white px-0 py-[8px] shadow-[0px_0px_12px_rgba(0,0,0,0.07)] lg:hidden',
    container: 'flex justify-between',
    item: 'flex-center focus:bg-system-gray-100 active:bg-system-gray-100 data-[selected=true]:bg-system-gray-100 cursor-pointer flex-col flex-wrap rounded-[100px] px-[20px] py-[8px] select-auto',
    menu: 'bg-system-gray-900 fixed top-0 right-0 bottom-16 left-0 min-h-[100vh] w-full overflow-auto',
    icon: 'relative',
    linkCounter:
      'bg-text-main-inversion text-text-main bg-icon-brand absolute -top-1 left-3 h-3 min-h-3 min-w-3 border-0 text-[8px]'
  }
});
